import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store-types";
import { ITechAssetsState } from "../shared";

import { TECH_ASSETS_MODULE_NAME } from "./constants";

export const getTechAssetsState = (rootState: RootState): ITechAssetsState =>
  rootState[TECH_ASSETS_MODULE_NAME];

export const getSelectedIds = createDraftSafeSelector(
  getTechAssetsState,
  (state: ITechAssetsState) => state.selectedIds
);

export const getSearchText = createDraftSafeSelector(
  getTechAssetsState,
  (state: ITechAssetsState) => state.searchText
);
